export default {
	TYPE: 'type',
	PLACE: 'place',
	PRODUCT_TYPE: 'product_type',
	PRODUCT_PLACE: 'product_place',
};
